// extracted by mini-css-extract-plugin
module.exports = {"DemoNav":"DemoNav_DemoNav__3R_C_"};